export enum EnumBloquearContratos {
    NaoBloquear = 0,
    BloquearContratos = 1,
    BloquearApenasCnpj = 2,
}

export const EnumBloquearContratosLabel: Record<EnumBloquearContratos, string> = {
    [EnumBloquearContratos.NaoBloquear]: 'Não',
    [EnumBloquearContratos.BloquearContratos]: 'Contratos',
    [EnumBloquearContratos.BloquearApenasCnpj]: 'Só CNPJ',
}

export const EnumBloquearContratosTooltip: Record<EnumBloquearContratos, string> = {
    [EnumBloquearContratos.NaoBloquear]: 'Acesso liberado normalmente.',
    [EnumBloquearContratos.BloquearContratos]: 'Bloqueia se for filial ou se tiver contratos vinculados.',
    [EnumBloquearContratos.BloquearApenasCnpj]: 'Bloqueia só o acesso deste CNPJ; outras filiais do contrato continuam funcionando.',
}

/** Compatível com API ainda retornando boolean enquanto o enum não estiver no backend. */
export function normalizeBloquearContratos(value: EnumBloquearContratos | boolean | number | null | undefined): EnumBloquearContratos {
    if (value === true) return EnumBloquearContratos.BloquearContratos
    if (value === false || value == null) return EnumBloquearContratos.NaoBloquear
    const num = Number(value)
    if (num === EnumBloquearContratos.BloquearContratos) return EnumBloquearContratos.BloquearContratos
    if (num === EnumBloquearContratos.BloquearApenasCnpj) return EnumBloquearContratos.BloquearApenasCnpj
    return EnumBloquearContratos.NaoBloquear
}
